const Urls = {
	Api: {
		form: '/my/api/2/order/request'
	},
	Templates: {
		app: '/my/api/2/templates?name=modules/product-in-stock/app-quote.html',
		help: '/my/api/2/templates?name=modules/product-in-stock/help.html'
	}
};

export default Urls;